<template>
  <span>
    <span v-if="value" :class="trueClass">Tak</span>

    <span v-else :class="falseClass">Nie</span>
  </span>
</template>

<script>
// Komponent do wyświetlenia wartości bitowej
export default {
  props: {
    // Wartość do wyświetlenia
    value: Boolean,
    // Klasa css do użycia dla wartości `Tak`
    trueClass: { type: String, default: 'text-bold' },
    // klasa css do użycia dla wartości `Nie`
    falseClass: { type: String, default: 'text-muted' }
  }
};
</script>
